import { Module } from 'vuex'
import { RootState } from '@ps/types/store'
import keys from '@ps/permission/keys'
import { PermissionState } from '@ps/types/store/permission.type'

const namespaced = true
const state: PermissionState = {
  common: [],
  workbench: [],
  keys,
}

const permission: Module<PermissionState, RootState> = {
  namespaced,
  state,

  mutations: {
    updateWorkbenchKeys(state, value: string[]) {
      state.workbench = value
    },
  },

  actions: {},
}

export default permission
